export enum Sorter {
  age = 'Newest',
  name = 'Alphabetically',
  price = 'Cheapest',
}
